import { IMeterSummary } from "./meterSummary.types"

export class MeterSummary implements IMeterSummary {
  constructor(
    public identifier: string,
    public type: string,
    public mpxns: string[],
  ) {}

  get isSmets2() {
    return this.type.startsWith("S2")
  }
}
